export default "__VITE_ASSET__DYN1J6N6__"